<template>
  <div class="wrapper">
    <base-bread-crumb
      :currBreadCrumb="currBreadCrumb"
      :isShowPortal="false"
    ></base-bread-crumb>
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          ref="elSearch"
          width="460px"
          :formProp="formData"
          @search="search"
          :isShowSearch="true"
          class="ccui-highsearch no-print"
        >
          <template slot="search">
            <el-date-picker
              v-model="formData.publishTime"
              searchLabel="发布时间"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
            <el-input
              v-model.trim="formData.title"
              clearable
              searchLabel="标题"
              placeholder="请输入标题模糊查询"
            ></el-input>
          </template>
          <el-date-picker
            v-model="formData.publishTime"
            searchLabel="发布时间"
            clearable
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            slot="searchItem1"
          >
          </el-date-picker>
          <el-input
            v-model.trim="formData.title"
            clearable
            searchLabel="标题"
            placeholder="请输入标题模糊查询"
            slot="searchItem2"
          ></el-input>
        </el-search>
      </div>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData.slice((pageNo - 1) * pageSize, pageNo * pageSize)"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
        >
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="checkDetail(row)"
            >
              {{ row.title }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { announcementPageSource } from "@/setting/setting";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  // queryPublishedNoticeList,
  searchPpBidNotice
} from "@/app/shop/api/shopping";
export default {
  name: "searchList",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      tableName: this.tableList.searchList, // 默认的tableName 工程中唯一
      currBreadCrumb: [{ title: "全部结果" }, { title: '"' + '"' }],
      formData: {
        title: ""
      },
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          checked: true
        },
        {
          label: "标题",
          prop: "title",
          // width: 500,
          checked: true,
          slot: "title",
          align: "left"
        },
        {
          label: "发布时间",
          prop: "publishTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0
    };
  },
  activated() {
    this.init();
  },
  deactivated() {
    this.tableData = [];
    this.currBreadCrumb = [{ title: "全部结果" }, { title: '"' + '"' }];
  },
  methods: {
    init() {
      //搜索方法
      /**
       * 1.通知公告
       * 2.工作动态
       * 3.评标结果
       * 4.采购公告
       *  **/
      let title = this.formData.title ? this.formData.title : this.name;
      let timeObj = {
        startTime: "",
        endTime: ""
      };
      if (this.formData.publishTime && this.formData.publishTime.length !== 0) {
        timeObj.startTime = this.formData.publishTime[0];
        timeObj.endTime = this.formData.publishTime[1];
      }
      Promise.all([
        // queryPublishedNoticeList({
        //   module: 1,
        //   pageState: 2,
        //   title: title,
        //   publishStartTime: timeObj.startTime,
        //   publishEndTime: timeObj.endTime
        // }),
        // queryPublishedNoticeList({
        //   module: 1,
        //   pageState: 2,
        //   textType: 2,
        //   title: title,
        //   publishStartTime: timeObj.startTime,
        //   publishEndTime: timeObj.endTime
        // }),
        // searchPpBidNotice({
        //   searchNoticeType: "100068ZBGG",
        //   noticeTitle: title,
        //   noticeTimeStart: timeObj.startTime,
        //   noticeTimeEnd: timeObj.endTime
        // }),
        searchPpBidNotice({
          searchNoticeType: "",
          noticeTitle: title,
          noticeTimeStart: timeObj.startTime,
          noticeTimeEnd: timeObj.endTime,
          isShowPageLoading: true
        })
      ]).then(res => {
        let tempData = [];
        // if (res[0].data.code === "0") {
        //   res[0].data.data.rows.map(item => {
        //     tempData.push({
        //       title: item.title,
        //       publishTime: item.publishTime
        //         ? moment(item.publishTime).format("YYYY-MM-DD HH:mm:ss")
        //         : "",
        //       source: announcementPageSource.notice,
        //       id: item.noticeInfoId,
        //       type: item.type
        //     });
        //   });
        // }
        // if (res[1].data.code === "0") {
        //   res[1].data.data.rows.map(item => {
        //     tempData.push({
        //       title: item.title,
        //       publishTime: item.publishTime
        //         ? moment(item.publishTime).format("YYYY-MM-DD HH:mm:ss")
        //         : "",
        //       source: announcementPageSource.dynamicWork,
        //       id: item.noticeInfoId,
        //       type: item.type
        //     });
        //   });
        // }
        // if (res[2].data.code === "0") {
        //   res[2].data.data.rows.map(item => {
        //     tempData.push({
        //       title: item.noticeTitle,
        //       publishTime: item.noticeStartTime
        //         ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm:ss")
        //         : "",
        //       source: announcementPageSource.evaluationResults,
        //       id: item.noticeId,
        //       schemeId: item.schemeId,
        //       type: item.type
        //     });
        //   });
        // }
        if (res[0].data.code === "0") {
          res[0].data.data.rows.map(item => {
            tempData.push({
              title: item.noticeTitle,
              publishTime: item.noticeStartTime
                ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm:ss")
                : "",
              source: announcementPageSource.purchaseAnnouncement,
              id: item.noticeId,
              schemeId: item.schemeId,
              type: item.type,
              textType: item.textType
            });
          });
        }
        //根据发布时间倒序排序
        tempData.sort(function(a, b) {
          return (
            Math.floor(new Date(b["publishTime"]).getTime() / 1000) -
            Math.floor(new Date(a["publishTime"]).getTime() / 1000)
          );
        });
        this.tableData = tempData;
        this.pageTotal = this.tableData.length;
      });
    },
    handleList() {
      // 分页操作列表
      this.init();
    },
    search() {
      this.pageNo = 1;
      this.init();
    },
    // 查看详情
    checkDetail(row) {
      this.$router.push({
        path: "/announcementDetail",
        query: {
          id: row.id,
          source: row.textType === 1 ? "2" : "3",
          schemeId: row.schemeId,
          type: row.type,
          noticeId: row.id
        }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    }
  },
  computed: {
    ...mapGetters(["getName"]),
    name: _this => {
      _this.currBreadCrumb[1].title = '"' + _this.getName + '"';
      return _this.getName;
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === "searchList") {
        this.formData.title = "";
        this.init();
      }
    }
  }
};
</script>

<style scoped></style>
